<template>
  <notification
    type="is-warning"
    icon="fa-clock"
    @delete="$emit('delete')"
    :snackbar="5"
  >
    Twoja sesja wygasła. Aby skorzystać z panelu administratora, zaloguj się
    ponownie.
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "token-expired-notification",

  components: {
    Notification
  }
};
</script>

<style></style>
